'use strict';

var planValidRules = function () {
  var _alphabetical = function _alphabetical(value) {
    if (value.trim() !== '') {
      var re = new RegExp(/^[A-Za-zÀ-ÿ\u00f1\u00d1\s'-.]+$/g);
      return re.test(value);
    } else {
      return true;
    }
  };

  var _cpES_AD = function _cpES_AD(value) {
    var re = new RegExp("^([0-4][0-9]{4}|(50|51|52)[0-9]{3}|AD[0-9]{3})$");
    return re.test(value);
  };

  var _cpPT = function _cpPT(value) {
    var re = new RegExp('^([0-9]{4}-[0-9]{3}|[0-9]{4})$');
    return re.test(value);
  };

  var _telfES_AD = function _telfES_AD(value) {
    if (value.trim() !== '') {
      var reES = new RegExp("^[6|7|8|9][0-9]{8}$");
      var excluded = ['600000000', '999999999', '666555444', '666777888', '666888999', '666111222', '666222333', '666333444', '666444555'];
      var reESExcept = new RegExp(/^(90|803|806|807)/);
      var reAN = new RegExp("^(00376|376)[0-9]{6}$");
      return reES.test(value) && !reESExcept.test(value) && !(excluded.indexOf(value) >= 0) || reAN.test(value);
    } else {
      return true;
    }
  };

  var _phoneESFixed = function _phoneESFixed(value) {
    if (value.trim() !== '') {
      var re = new RegExp("^[8|9][0-9]{8}$");
      var excluded = ['999999999'];
      var reExcept = new RegExp(/^(90|803|806|807)/);
      return re.test(value) && !reExcept.test(value) && !(excluded.indexOf(value) >= 0);
    } else {
      return true;
    }
  };

  var _phoneESMobile = function _phoneESMobile(value) {
    if (value.trim() !== '') {
      var re = new RegExp("^[6|7][0-9]{8}$");
      var excluded = ['600000000', '666555444', '666777888', '666888999', '666111222', '666222333', '666333444', '666444555'];
      return re.test(value) && !(excluded.indexOf(value) >= 0);
    } else {
      return true;
    }
  };

  var _telfPT = function _telfPT(value) {
    if (value.trim() !== '') {
      var re = new RegExp("^[9,2][0-9]{8}$");
      return re.test(value);
    }
  };

  var _emailStrict = function _emailStrict(value) {
    if (value.trim() !== '') {
      var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      return re.test(value) && value === encodeURI(value);
    }
  };

  var _nifNie = function _nifNie(value) {
    var controlDigits = 'TRWAGMYFPDXBNJZSQVHLCKE';
    var nifCorrectFormat = function nifCorrectFormat(value) {
      return (/^[0-9]{8}[A-Z]{1}$/.test(value)
      );
    };
    var nieCorrectFormat = function nieCorrectFormat(value) {
      return (/^[A-Z]{1}[0-9]{7}[A-Z]{1}$/.test(value)
      );
    };
    var controlDigitOK = function controlDigitOK(value) {
      var nums = value.substring(8, 0);
      var lastLetter = value.substring(8);
      var mod = nums % 23;
      return lastLetter === controlDigits.charAt(mod);
    };

    if (nifCorrectFormat(value)) {
      return controlDigitOK(value);
    } else {
      if (nieCorrectFormat(value)) {
        value = value.replace('X', '0');
        value = value.replace('Y', '1');
        value = value.replace('Z', '2');
        return controlDigitOK(value);
      } else {
        return false;
      }
    }
  };

  var _ccOrBi = function _ccOrBi(value) {
    var ccCorrectFormat = function ccCorrectFormat(value) {
      return (/^[0-9A-Z]{12}$/.test(value)
      );
    };
    var biCorrectFormat = function biCorrectFormat(value) {
      return (/^[0-9]{9}$/.test(value)
      );
    };

    var isCorrectCC = function isCorrectCC(value) {
      var positions = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var strArray = value.split('').reverse();
      var posArray = strArray.map(function (n) {
        return positions.indexOf(n);
      });
      var multiplyAndSubstract9 = posArray.map(function (n, i) {
        var m = void 0;
        if ((i + 1) % 2 === 0) {
          m = n * 2;
          if (m > 9) {
            m -= 9;
          }
          return m;
        } else {
          return n;
        }
      });
      var sum = multiplyAndSubstract9.reduce(function (a, b) {
        return a + b;
      }, 0);
      return sum % 10 === 0;
    };

    var isCorrectBi = function isCorrectBi(value) {
      var strArray = value.split('').reverse();
      var multiplyByIndex = strArray.map(function (n, i) {
        return n * (i + 1);
      });
      var sum = multiplyByIndex.reduce(function (a, b) {
        return a + b;
      }, 0);
      return sum % 11 === 0;
    };

    if (ccCorrectFormat(value)) {
      return isCorrectCC(value);
    } else {
      if (biCorrectFormat(value)) {
        return isCorrectBi(value);
      } else {
        return false;
      }
    }
  };

  var _cif = function _cif(value) {
    if (/^[A-Z0-9]{9}$/.test(value)) {
      var sevenDigitsArray = value.substring(1, 8).split('');
      var odd = sevenDigitsArray.filter(function (n, i) {
        if ((i + 1) % 2 === 0) {
          return n;
        }
      });
      var sumOdd = odd.reduce(function (a, b) {
        return parseInt(a) + parseInt(b);
      }, 0);
      var even = sevenDigitsArray.filter(function (n, i) {
        if ((i + 1) % 2 !== 0) {
          return n;
        }
      });
      var sumEven = even.map(function (n) {
        var doubledigit = String(n * 2).split('');
        var sum = doubledigit.reduce(function (a, b) {
          return parseInt(a) + parseInt(b);
        }, 0);
        return sum;
      });
      var sumEven2 = sumEven.reduce(function (a, b) {
        return parseInt(a) + parseInt(b);
      }, 0);
      var sumOddAndEven2 = sumOdd + sumEven2;
      var units = 10 - parseInt(String(sumOddAndEven2).split('')[1]) - 1;
      var controlChars = 'ABCDEFGHIJ';
      var controlCharacter = controlChars.charAt(units);
      var controlCharIndex = controlChars.indexOf(controlCharacter) + 1;
      var lastChar = value.substring(8, 9);
      if (isNaN(parseInt(lastChar))) {
        return lastChar === controlCharacter;
      } else {
        return parseInt(lastChar) === controlCharIndex;
      }
    } else {
      return false;
    }
  };

  var _nipc = function _nipc(value) {
    if (/^[0-9]{9}$/.test(value)) {
      var controlNumber = parseInt(value.substring(8, 9));
      var strArray = value.substring(0, 8).split('').reverse();
      var multiplyByIndexAndSum = strArray.map(function (n, i) {
        return n * (i + 2);
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var mod11 = multiplyByIndexAndSum % 11;
      var finalVal = mod11 === 1 || mod11 === 0 ? 0 : 11 - mod11;
      return finalVal === controlNumber;
    } else {
      return false;
    }
  };

  return {
    alphabetical: _alphabetical,
    cpES_AD: _cpES_AD,
    cpPT: _cpPT,
    telfES_AD: _telfES_AD,
    telfPT: _telfPT,
    phoneESFixed: _phoneESFixed,
    phoneESMobile: _phoneESMobile,
    emailStrict: _emailStrict,
    nifNie: _nifNie,
    ccOrBi: _ccOrBi,
    cif: _cif,
    nipc: _nipc
  };
}();